import { render } from "./RefundDetailComponent.vue?vue&type=template&id=23ee5801&scoped=true"
import script from "./RefundDetailComponent.vue?vue&type=script&lang=js"
export * from "./RefundDetailComponent.vue?vue&type=script&lang=js"

import "./RefundDetailComponent.vue?vue&type=style&index=0&id=23ee5801&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23ee5801"]])

export default __exports__